var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCollect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1254_19133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.8634 4.13609C14.9509 6.31175 15.5549 8.71354 15.707 11.1409H27.2928C27.4446 8.71384 28.0486 6.31175 29.1361 4.13609L29.3771 3.65407C29.597 3.21459 29.511 2.68347 29.1629 2.33534C28.816 1.98721 28.2849 1.90122 27.8442 2.12111L24.0103 4.0379L22.3074 2.33534C21.8611 1.88902 21.1381 1.88902 20.6918 2.33534L18.9892 4.0379L15.1553 2.12081C14.7135 1.90122 14.1859 1.98602 13.8366 2.33534C13.4885 2.68317 13.4025 3.21429 13.6224 3.65407L13.8634 4.13609Z",
    fill: "url(#paint0_linear_1254_19133)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 16.3,
    width: 13,
    height: 19.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4953 13.5023H14.5041L10.043 18.9015C7.85274 21.5539 6.64648 24.9872 6.64648 28.4319C6.64648 36.067 12.4766 41 21.4997 41C30.5231 41 36.3532 36.067 36.3532 28.4319C36.3532 24.9872 35.1469 21.63 32.9555 18.9777L28.4953 13.5023ZM21.4875 25.3389C23.3778 25.3389 24.9152 26.8764 24.9152 28.7667C24.9152 30.2496 23.9631 31.5032 22.6423 31.9799V33.0022C22.6423 33.6336 22.1314 34.1448 21.4997 34.1448C20.8683 34.1448 20.3574 33.6336 20.3574 33.0022V31.9876C19.0238 31.5178 18.0598 30.2586 18.0598 28.7667C18.0598 28.135 18.5709 27.6241 19.2023 27.6241C19.834 27.6241 20.3449 28.135 20.3449 28.7667C20.3449 29.3972 20.8573 29.9092 21.4875 29.9092C22.118 29.9092 22.6301 29.3972 22.6301 28.7667C22.6301 28.1362 22.118 27.6241 21.4875 27.6241C19.5975 27.6241 18.0598 26.0864 18.0598 24.1964C18.0598 22.7042 19.0238 21.4453 20.3574 20.9754V19.2913C20.3574 18.6599 20.8683 18.1487 21.4997 18.1487C22.1314 18.1487 22.6423 18.6599 22.6423 19.2913V20.9832C23.9631 21.4598 24.9152 22.7134 24.9152 24.1964C24.9152 24.8281 24.4043 25.3389 23.7726 25.3389C23.1413 25.3389 22.6301 24.8281 22.6301 24.1964C22.6301 23.5662 22.118 23.0538 21.4875 23.0538C20.8573 23.0538 20.3449 23.5662 20.3449 24.1964C20.3449 24.8269 20.857 25.3389 21.4875 25.3389Z",
    fill: "url(#paint1_linear_1254_19133)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 32.7273,
    y: 12.2,
    width: 3.54545,
    height: 7.7,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.757 18.6222L35.8572 10.7581C35.5779 10.2906 35.0582 10 34.4987 10C33.9391 10 33.4194 10.2906 33.1475 10.7471L28.2561 18.5983C27.5833 19.5819 28.3081 21 29.5915 21H39.4058C40.7041 21 41.4001 19.5572 40.757 18.6222ZM34.4987 19.625C33.9864 19.625 33.5707 19.2143 33.5707 18.7083C33.5707 18.2023 33.9864 17.7917 34.4987 17.7917C35.0109 17.7917 35.4266 18.2023 35.4266 18.7083C35.4266 19.2143 35.0109 19.625 34.4987 19.625ZM35.4266 15.9583C35.4266 16.4643 35.0118 16.875 34.4987 16.875C33.9855 16.875 33.5707 16.4643 33.5707 15.9583V13.2083C33.5707 12.7023 33.9855 12.2917 34.4987 12.2917C35.0118 12.2917 35.4266 12.7023 35.4266 13.2083V15.9583Z",
    fill: "#BE0B0B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1254_19133",
    x1: 13.5017,
    y1: 6.57049,
    x2: 29.4978,
    y2: 6.57049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D39118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB43"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1254_19133",
    x1: 6.64648,
    y1: 27.2511,
    x2: 36.3532,
    y2: 27.2511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D39118"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCB43"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1254_19133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCollect);
export default __webpack_public_path__ + "static/media/icon_collect.2f24a0cb25f705b193c8d026b0830d76.svg";
export { ForwardRef as ReactComponent };